import React, { memo } from "react";
import useSignUpForm from "./index.hooks";
import { TextField, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";
import { AppButton } from "components";
import { CognitoAuthenticationStatus } from "../../redux-store/slices/cognito/interfaces";

type SignUpFormProps = {};

const SignUpForm = ({}: SignUpFormProps) => {
  const {
    styles,
    register,
    onSubmit,
    handleSubmit,
    errors,
    fields,
    cognitoAuthStatus,
    register2,
    handleSubmit2,
    onVerificationCodeSubmit,
    t,
  } = useSignUpForm();

  return (
    <div className={styles.formContainer}>
      <Typography className={styles.formTitle}>{t("Registrati")}</Typography>
      {cognitoAuthStatus === CognitoAuthenticationStatus.WaitingConfirmCode ? (
        <form onSubmit={handleSubmit2(onVerificationCodeSubmit)}>
          <Typography>{t("Confirm code!")}</Typography>
          <TextField
            variant="outlined"
            label={t("Codice di verifica")}
            name="code"
            className={styles.inputField}
            inputRef={register2}
            fullWidth
          />
          <AppButton
            color="primary"
            type="submit"
            variant="contained"
            fullWidth
          >
            {t("Conferma!")}
          </AppButton>
        </form>
      ) : (
        <form onSubmit={handleSubmit(onSubmit)}>
          {fields.map((elm) => (
            <TextField
              key={elm.name}
              variant="outlined"
              label={elm.label}
              name={elm.name}
              type={elm.type}
              className={styles.inputField}
              inputRef={register}
              error={!!errors[elm.name]}
              helperText={errors[elm.name]?.message}
              fullWidth
            />
          ))}
          <Typography className={styles.termsContainer}>
            {t("Registrandoti accetti i nostri")}{" "}
            <Link to="/">{t("termini di servizio")}</Link> e la nostra{" "}
            <Link to="/">{t("privacy policy")}</Link>
          </Typography>
          <AppButton
            color="primary"
            type="submit"
            variant="contained"
            fullWidth
          >
            {t("Iniziamo!")}
          </AppButton>
        </form>
      )}
      <Typography className={styles.member}>
        {t("Sei gi\u00E1 registrato?")} <Link to="/login/">{t("Accedi")}</Link>
      </Typography>
    </div>
  );
};

export default memo(SignUpForm);
